<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card class="md-card-plain">
          <md-card-header data-background-color="green">
            <h4 class="title">Novi Unosi</h4>
            <p class="category">Da bi se ovi unosi našli u finalnoj tabeli i grafikonima prvo ih morate ispraviti i odobriti</p>
          </md-card-header>
          <md-card-content>
            <staging-table></staging-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { StagingTable} from "@/components";

export default {
  components: {
    StagingTable
  }
};
</script>
